import { render, staticRenderFns } from "./searchCourses.vue?vue&type=template&id=3d51a642&"
import script from "./searchCourses.vue?vue&type=script&lang=js&"
export * from "./searchCourses.vue?vue&type=script&lang=js&"
import style0 from "./searchCourses.vue?vue&type=style&index=0&id=3d51a642&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports